var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"LeasePeriodsTableActions"},[_c('v-btn',{attrs:{"icon":"","small":"","color":"primary"},on:{"click":function($event){return _vm.editPaymentPlan()}}},[_c('v-icon',{attrs:{"small":""}},[_vm._v(" edit ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }